import { Component } from "react";
import { COMPANY } from "@/content";

export default class ErrorBoundary extends Component {
  state = { hasError: false };
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(err) { console.error("App error:", err); }
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div data-testid="app-error-fallback" className="min-h-screen grid place-items-center bg-bone px-5 text-center">
        <div>
          <img src="/logo.png" alt={COMPANY.full} className="h-20 w-auto mx-auto mb-8" />
          <h1 className="font-heading text-3xl md:text-4xl text-charcoal">Something went wrong loading this page.</h1>
          <p className="mt-3 text-ink">Please refresh — or call us anytime at <a href={COMPANY.phoneHref} className="text-terracotta font-semibold">{COMPANY.phone}</a>.</p>
          <button onClick={() => window.location.reload()} className="mt-7 rounded-full bg-terracotta px-7 py-3.5 font-semibold text-bone hover:bg-terracotta-dark transition-colors">Refresh page</button>
        </div>
      </div>
    );
  }
}
